import React, {PropTypes} from 'react'
import {connect} from 'react-redux'
import {Row, Button, ButtonGroup} from 'react-bootstrap'
import {Actions} from 'jumpstate'
import BreederBox from './BreederBox/BreederBox'
import OwnerBox from './OwnerBox/OwnerBox'
import AdBox from './AdBox/AdBox'
import showToastr from '../../../utils/showToastr'

class HorseBreederOwner extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      isBreederBoxVisible: false,
      isOwnerBoxVisible: false,
      isAdBoxVisible: false
    }
    this.breederHandler = this.breederHandler.bind(this)
    this.ownerHandler = this.ownerHandler.bind(this)
    this.adHandler = this.adHandler.bind(this)
  }

  adHandler (show = true) {
    const {auth} = this.props
    if (!auth.isAuthenticated) {
      showToastr('warning', '', 'لازم است به حساب خود وارد شوید')
      Actions.toggleLoginBox(true)
      return undefined
    }
    this.setState({isAdBoxVisible: show})
  }

  breederHandler (show = true) {
    const {auth} = this.props
    if (!auth.isAuthenticated) {
      showToastr('warning', '', 'لازم است به حساب خود وارد شوید')
      Actions.toggleLoginBox(true)
      return undefined
    }
    this.setState({isBreederBoxVisible: show})
  }

  ownerHandler (show = true) {
    const {auth} = this.props
    if (!auth.isAuthenticated) {
      showToastr('warning', '', 'لازم است به حساب خود وارد شوید')
      Actions.toggleLoginBox(true)
      return undefined
    }
    this.setState({isOwnerBoxVisible: show})
  }

  render () {
    const {horse, user} = this.props
    return (
      <Row className="Box box-breeder-owner">
        <BreederBox isVisible={this.state.isBreederBoxVisible} toggler={this.breederHandler} horse={horse} />
        <OwnerBox isVisible={this.state.isOwnerBoxVisible} toggler={this.ownerHandler} horse={horse} />
        {user && <AdBox isVisible={this.state.isAdBoxVisible} toggler={this.adHandler} horse={horse} user={user} />}

        <ButtonGroup>
          <Button disabled={horse.isBreeder} onClick={() => this.breederHandler()} bsStyle="success" >پرورش دهنده هستم</Button>
          {!horse.isOwner && <Button disabled={horse.isOwner} bsStyle="primary" onClick={() => this.ownerHandler()} >مالک هستم</Button>}
          {horse.isOwner && <Button bsStyle="warning" onClick={() => this.adHandler(true)} >ثبت آگهی</Button>}
        </ButtonGroup>
      </Row>
    )
  }
}

HorseBreederOwner.propTypes = {
  horse: PropTypes.object.isRequired
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    user: state.user.currentUser
  }
}

export default connect(mapStateToProps)(HorseBreederOwner)



// WEBPACK FOOTER //
// ./src/components/HorseInfo/HorseBreederOwner/HorseBreederOwner.js